import React from 'react'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'
import LanguageSelect from '../LanguageSelect'
import { useDispatch, useSelector } from 'react-redux'
import './styles/index.scss'
import Icon from 'icons/Icon'
import Button from 'components/Common/Button'
import { BUTTON_VARIANT } from 'utils/constants'
import { closeModal, openModal } from 'store/redux-slices/modal'
import { MODALS } from 'constants/modals'
import ConfirmSignupCancellation from 'components/ConfirmSignupCancellation'
import { Routes } from 'utils/routes'

const LoginHeading = ({ language, setLanguage, langKey, anotherKey, loading }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { languageData, selectedLanguageCode } = useSelector(state => state.language)
  const showSignupCancellationModal = useSelector((state) => {
    const flag = state?.uiConfig?.general?.showSignupCancellationModal
    return flag === true || flag === 'true'
  })
  const isSignupPage = Boolean(matchPath({ path: Routes.signup, end: true }, location.pathname))

  const goHome = () => navigate(`/${selectedLanguageCode?.toLowerCase()}`)

  const handleClose = () => {
    if (isSignupPage && showSignupCancellationModal) {
      dispatch(openModal({
        name: MODALS.CANCEL_SIGNUP_CONFIRMATION_MODAL,
        body: (
          <ConfirmSignupCancellation
            onPrimaryClick={() => {
              dispatch(closeModal(MODALS.CANCEL_SIGNUP_CONFIRMATION_MODAL))
            }}
            onSecondaryClick={() => {
              dispatch(closeModal(MODALS.CANCEL_SIGNUP_CONFIRMATION_MODAL))
              goHome()
            }}
          />
        ),
        onClose: () => {
          dispatch(closeModal(MODALS.CANCEL_SIGNUP_CONFIRMATION_MODAL))
        },
        modalProps: {
          className: 'cancel-signup-modal-wrapper'
        }
      }))
      return
    }
    goHome()
  }

  return (
    <div className='login-heading'>
      <Button
        variant={BUTTON_VARIANT.CONTENT_ONLY}
        type='button'
        onClick={handleClose}
        className='close-button-login-signup'
      >
        <Icon name='xmark' className='img-fluid d-block mx-auto' width='32' height='32' />
      </Button>
      <div className='logo-text m-auto'>
        <img
          loading='lazy'
          src={`${process.env.REACT_APP_STATIC_IMAGE}/Vector.svg`}
          className='tenant-logo-user-auth m-auto h-auto'
          alt='tenant-logo-user-auth'
        />
        <span className='signup-title'>{languageData?.[langKey]} {anotherKey ? languageData?.[anotherKey] : ''}</span>
      </div>

      <div className='dropdown-btn language-selector'>
        <LanguageSelect language={language} setLanguage={setLanguage} login />
      </div>
    </div>
  )
}

export default LoginHeading
